import type {ReactNode} from "react";

export type AsyncStateKind = "loading" | "empty" | "error" | "unavailable" | "restricted";

const copy: Record<AsyncStateKind, {title: string; role?: "alert" | "status"}> = {
  loading: {title: "Loading governed data", role: "status"},
  empty: {title: "No governed records in this scope", role: "status"},
  error: {title: "The governed data could not be loaded", role: "alert"},
  unavailable: {title: "This live source is unavailable", role: "status"},
  restricted: {title: "Permission required", role: "status"}
};

export function AsyncState({kind, detail, action}: {
  kind: AsyncStateKind;
  detail: string;
  action?: ReactNode;
}) {
  return <section className={`async-state async-${kind}`} role={copy[kind].role}
    aria-live={kind === "error" ? "assertive" : "polite"}>
    <span className="state-symbol" aria-hidden="true">{symbol(kind)}</span>
    <div><h2>{copy[kind].title}</h2><p>{detail}</p>{action}</div>
  </section>;
}

function symbol(kind: AsyncStateKind) {
  return ({loading: "…", empty: "○", error: "!", unavailable: "—", restricted: "×"})[kind];
}
